export const SET_BOOKINGS = 'SET_BOOKINGS';
export const SET_BOOKINGS_PAGINATION = 'SET_BOOKINGS_PAGINATION';
